/* 🤖 this file was generated by svg-to-ts */
export const PorIconChevronleft: {
    name: 'chevronleft';
    data: string;
} = {
    name: 'chevronleft',
    data: `<!--From https://fonts.google.com/icons Icon: Chevron Left, Weight: 700 Grade: 200--><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 96 960 960" width="24"><path d="M561 837 298 575l263-263 65 65-198 198 198 197-65 65Z"/></svg>`
};
